import { useState } from 'react'

import { services } from 'core/nft/data-access'
import { useMemoizedFn, useMountedPromiseFn } from 'shared/hooks'

import type { NftFormData } from '../models'

export const useNftEdit = () => {
    const [loading, setLoading] = useState(false)

    const editApi = useMountedPromiseFn(services.edit)
    const edit = useMemoizedFn((formData: NftFormData) => {
        setLoading(true)
        console.log(formData)
        return editApi(formData)
            .then(() => {
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                return Promise.reject(err)
            })
    })
    return {
        loading,
        methods: { edit }
    }
}
